import Router from './router'

/**
 * Router adapted from page.js
 * @see https://github.com/visionmedia/page.js
 */
export default Router
